import React from "react";
import styled from "styled-components";

const PrivacyPolicy = () => {

    return(
        <Container>
            <div className="content-field">

            </div>
        </Container>
    );

};

const Container = styled.div`

    
    h2{
           
    }
`

export default PrivacyPolicy;